import type { LocalDate } from './recurringRules'

/** `month` is 1–12. */
export type YearMonth = { year: number; month: number }

const PARAM = /^(\d{4})-(0[1-9]|1[0-2])$/

export function currentOf(today: LocalDate): YearMonth {
  return { year: Number(today.slice(0, 4)), month: Number(today.slice(5, 7)) }
}

/** `?month=YYYY-MM`. Anything that is not exactly that falls back to the current month. */
export function readMonth(params: URLSearchParams, today: LocalDate): YearMonth {
  const m = PARAM.exec(params.get('month') ?? '')
  if (!m) return currentOf(today)
  return { year: Number(m[1]), month: Number(m[2]) }
}

/** The current month is the default, so it leaves the URL clean. */
export function writeMonth(ym: YearMonth, today: LocalDate): URLSearchParams {
  const cur = currentOf(today)
  const params = new URLSearchParams()
  if (ym.year !== cur.year || ym.month !== cur.month) {
    params.set('month', `${ym.year}-${String(ym.month).padStart(2, '0')}`)
  }
  return params
}

/** Calendar-month arithmetic: `n` may be negative, the year rolls. */
export function addMonths(ym: YearMonth, n: number): YearMonth {
  const index = ym.year * 12 + (ym.month - 1) + n
  return { year: Math.floor(index / 12), month: (index % 12) + 1 }
}

export function nextMonth(ym: YearMonth): YearMonth {
  return addMonths(ym, 1)
}

/** D10: six months back, the current month, five ahead. */
export function stripWindow(today: LocalDate): YearMonth[] {
  const cur = currentOf(today)
  const out: YearMonth[] = []
  for (let offset = -6; offset <= 5; offset += 1) out.push(addMonths(cur, offset))
  return out
}
